<template>
  <div class="code">
    <input class="regist-ipt" type="text" v-model.number="info.smsCode" @focus="clearError(0)" :placeholder="$t('common.inputCode')">
    <a class="getCode" v-show="!showtime" @click="sendSmsCode">{{$t("common.code")}}</a>
    <span v-show="showtime" class="time">{{count}}s</span>
    <p class="ui-error" v-if="error === 1">{{$t("common.codeTip")}}</p>
  </div>
</template>
<script>
import {sendSmsCode, sendEmailCode} from '@/service/loginAndRegistApi.js'
export default {
  props: ['info', 'error', 'ipt'],
  data(){
    return {
      count: 0,
      showtime: false,
      inter: '',
    }
  },
  methods: {
    async sendSmsCode(){
      if(this.count === 0 && this.ipt){
        // const reg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
        const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        // console.log(this.ipt);
        // console.log(reg.test(this.ipt));
        // return
        // // return
        let res
        if(reg.test(this.ipt)){
          res = await sendEmailCode({email: this.ipt})
        }else{
          res = await sendSmsCode({mobileNO: this.ipt})
        }
        if(res.data.status === 1){
          this.$parent.info.time = res.data.time
          this.$parent.info.checksum = res.data.checksum
          this.count = 60
          this.showtime = true
          this.inter = setInterval(()=>{
            this.count --
            if(this.count === 0){
              this.showtime = false
              clearInterval(this.inter)
            }
          }, 1000)
        }
      }else if(this.ipt.length === 0){
        this.$emit('setError', 1)
      }
    },
    clearError(){
      this.$emit('clearError')
    }
  },
  destroyed(){
    clearInterval(this.inter)
  }
}
</script>
<style lang="scss" scoped>
.regist-ipt{
  width: 100%; height: 42px; border-radius: 42px; background: #ededed; border: 1px solid #ededed; padding: 10px 22px 10px 70px; line-height: 20px;
  &:focus{border-color: #002147;}
}
.code{
  margin-top: 30px; position: relative;
  .getCode,.time{position: absolute; top: 5px; right: 5px; height: 32px; background: #002147; border-radius: 32px; text-align: center; line-height: 32px; color: #fff; padding: 0 20px; min-width: 100px;}
  .time{background: #a0a0a0;}
  .regist-ipt{padding: 10px 120px 10px 70px; background: #ededed url(../assets/phone3.png) no-repeat 23px center;}
}
</style>